import { RouteNames } from '~/src/router/constants';
export const notRoutes = [RouteNames.CERT_EVALUATE];
